/**
 * Created by afuhr on 20.09.2016.
 */
import {
  IAdminUnitRecord,
  ISession,
  ISessionRecord,
  IUser,
  IUserRecord,
  Message,
  MessageList,
  MessageRecord,
  MessageType
} from "./session.types";
import {makeTypedFactory} from "typed-immutable-record";
import {makeTypedFactoryList} from "../typed-list";
import {AdministrationUnit} from "../../view-model/organization/administration-unit.type";


export const UserFactory = makeTypedFactory<IUser, IUserRecord>({
  cuid: null,
  label: null,
  name: null,
  pre_name: null,
  email: null,
  form_of_address: null,
  academic_title: null,
  customer_id: null,
  administration_units: [],
  permissions: [],
  roles: []
});

export const INITIAL_USER_STATE = UserFactory();

export const MessageFactory = makeTypedFactory<Message, MessageRecord>({
  message: null,
  type: MessageType.INFO
});

export const MessageListFactory = makeTypedFactoryList<Message, MessageList>();

export const INITIAL_MESSAGE_LIST_STATE = MessageListFactory();

export const AdminUnitFactory = makeTypedFactory<AdministrationUnit, IAdminUnitRecord>({
  cuid: null,
  label: null,
  name: null,
  address_name: null,
  address: null,
  billing_address: null,
  business_relations: [],
  is_supplier: null,
  is_central_depot: false,
  forced_supplier: null,
  manages_external_depots: [],
  depots_managed_by_external_admin_unit: [],
  is_manager_of_external_depots: false,
  is_managed_by_external_admin_units: false,

  stocks: []
});

export const INITIAL_ADMIN_UNIT_STATE = AdminUnitFactory();

export const SessionFactory = makeTypedFactory<ISession, ISessionRecord>({
  token: null,
  loggedIn: false,
  user: INITIAL_USER_STATE,
  activeAdminUnit: null,
  activeAdminUnitData: INITIAL_ADMIN_UNIT_STATE,
  hasError: false,
  isLoading: false,
  redirectUrl: "",
  messages: INITIAL_MESSAGE_LIST_STATE
});


export const INITIAL_STATE = SessionFactory();




// WEBPACK FOOTER //
// ./src/app/shared/redux-store/session/session.initial-state.ts